import React from "react";
import {UserStorage} from "../../units";
import {Link, useHistory} from "react-router-dom";
import ImageBox from "../../components/Image";
import Sex from "./sex";
import DatePickerBox from "./datePicker";
import {postUserBirthday, postUserRegion} from "../../service";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";
import ActionSheet from "../../components/actionSheet";

const tfTime = (userInfo: UserStorage): Date | undefined => {
    // console.log(userInfo)
    if (userInfo.birthday) {
        return new Date(Date.parse(userInfo.birthday.replace(/-/g, "/")))
    }
    return undefined
}

const list = ['中国地区','港澳台地区','其他国家']

function UserInfo() {

    const userInfo = useUserInfo()
    const loading = useLoading()
    const history = useHistory()
    const dispatch = useDispatch()

    const timeChange = (time: string) => {
        if (userInfo) {
            loading.showLoading()
            postUserBirthday({
                userId: userInfo.id,
                birthday: time
            }).then(res => {
                if (res.code === 1) {
                    loading.showSuccess()
                    dispatch(userInfoAction(Object.assign({},userInfo,{ birthday:time })))
                }else{
                    loading.showError()
                }
            }).catch(e => {
                loading.showError()
            })
        }
    }

    const ExitHandle = () => {
        localStorage.removeItem('userData')
        dispatch(userInfoAction(null))
        history.replace('/')
    }

    const regionChange = (s:string) => {
        if(userInfo){
            const region = list.findIndex(item => item === s).toString()
            postUserRegion({
                userId:userInfo.id,
                region
            }).then(res => {
                if(res.code === 1){
                    dispatch(userInfoAction(Object.assign({},userInfo,{ region })))
                    loading.showSuccess()
                }else{
                    loading.showError(res.msg)
                }
            })
        }

    }

    return <div className="user" style={{height: '100vh'}}>

        {/*<div className="space"/>*/}
        <div className="lists" style={{paddingTop: '.25rem',backgroundColor:'#f3f3f3'}}>
            <div className="card">

                <Link to={'/user/info/avatar'}>
                    <div className="name">
                        <p className='title'>用户头像</p>
                    </div>
                    <div>
                        {
                            userInfo?.avatarUrl ?  <div style={{display: "inline-block", width: '.9rem', margin: '-.1rem .1rem'}}>
                                <ImageBox radius={50} src={userInfo?.avatarUrl} height={100}/>
                            </div> :  <span className="text" style={{ opacity: .6 }}>上传</span>
                        }

                        <span className="iconfont">&#xe608;</span>
                    </div>
                </Link>

                <Link to={'/user/info/nickname'}>
                    <div className="name">
                        <p className='title'>用户昵称</p>
                    </div>

                    <p>
                        <span className="text">{userInfo?.nickName || '填写'}</span>
                        <span className="iconfont">&#xe608;</span>
                    </p>
                </Link>

                <div className='a'>
                    <div className="name">
                        <p className='title'>用户性别</p>
                    </div>
                    <Sex sex={userInfo ? userInfo.sex !== undefined ? userInfo.sex : 0 : 0}/>
                </div>
                <div className='a' style={{padding: '.08rem 0 .08rem .3rem'}}>
                    <div className="name">
                        <p className='title'>出生日期</p>
                    </div>
                    <DatePickerBox value={userInfo ? tfTime(userInfo) : undefined } onChange={timeChange}/>
                </div>
                <div className='a'>
                    <div className="name">
                        <p className='title'>用户地区</p>
                    </div>
                    <ActionSheet label={'选择地区'} onChange={ (s) => regionChange(s) } list={ list } value={ userInfo?.region || 0 } placeholder={ '请选择地区' }/>
                </div>
            </div>

            <div className="space"/>

            <div className="card">
                <Link to={'/user/info/resume/name'}>
                    <div className="name">
                        <p className='title'>真实姓名</p>
                    </div>
                    <p>
                        {
                            userInfo?.fullName ?  <span className="text">{ userInfo?.fullName }</span> :  <span className="text" style={{ opacity:'.5' }}>未设置</span>
                        }

                        <span className="iconfont">&#xe608;</span>
                    </p>
                </Link>

                <Link to={'/user/info/identity'}>
                    <div className="name">
                        <p className='title'>身份证号</p>
                    </div>
                    <p>
                        <span className="text">{userInfo?.idNumber}</span>
                        <span className="iconfont">&#xe608;</span>
                    </p>
                </Link>
                <Link to={'/user/info/change-phone'}>
                    <div className="name">
                        <p className='title'>更换手机</p>
                    </div>
                    <p>
                        <span className="text">{userInfo?.customerMobile}</span>
                        {/*<span className="text">更换</span>*/}
                        <span className="iconfont">&#xe608;</span>
                    </p>
                </Link>
            </div>

            <div className="space"/>

            <div className="card">
                <Link to={'/user/info/resume'} className="exit" style={{border: 'none', justifyContent: 'center',color:'#012C6D'}}>
                    <div className="name">
                        <p className='title'>在线简历</p>
                    </div>
                </Link>
            </div>

            <div className="space"/>

            <div className="card">
                <div className='exit a' style={{border: 'none', justifyContent: 'center'}} onClick={ExitHandle}>
                    <div className="name">
                        <p className='title' style={{margin: 0}}>退出登录</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
}


export default UserInfo
